export default __webpack_public_path__ + "static/media/ab2c8f1c7ee4b289db83dd30680ed807.svg";